import { createUndefinedObject, pushDataLayer } from './utils';

interface ResourceData {
  topic_id?: string | number;
  topic_name?: string;
  theme_id?: string | number;
  theme_name?: string;
}

export const trackResource = async (data: ResourceData) => {
  pushDataLayer<ResourceData>('resourceViewed', data);
};

export const clearResourceDataLayer = () => {
  const resourceDataUndefined = createUndefinedObject<ResourceData>();
  pushDataLayer<ResourceData>('clearResourceViewed', resourceDataUndefined);
};
